import React, { FormEvent, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import InputFeild from "src/Components/InputFeild";
import CircleButton from "src/Components/GlobalComponents/CircleButton";
import { validatePassword } from "src/helpers/helperFunctions";
import { errMsg } from "src/lib/constans";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";

interface IPayloadState {
    email: string;
    otp: string;
    newPassword: string;
    cnfrmPassword: string;
};

const initialState: IPayloadState = {
    email: "",
    otp: "",
    newPassword: "",
    cnfrmPassword: "",
};

const initialErroState = {
    newPassword: "",
    cnfrmPassword: "",
};

const DoctorConfirmPassword: React.FC = () => {
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [errorField, setErrorField] = useState(initialErroState);
    const [payload, setPayload] = useState<IPayloadState>(initialState);

    const handleChange = (key: keyof IPayloadState, val: string) => {
        setPayload(prev => ({ ...prev, [key]: val }));
        if (val) {
            setErrorField(prev => ({ ...prev, [key]: "" }));
        }
    };

    const validateFields = () => {
        const errors: typeof errorField = {
            newPassword: !payload.newPassword ? "Password is required." : !validatePassword(payload.newPassword) ? errMsg.invalidPassword : "",
            cnfrmPassword: !payload.cnfrmPassword ? "Confirm password is required." : payload.newPassword !== payload.cnfrmPassword ? "Password and Confirm password must match." : "",
        };
        setErrorField(errors);
        // Check if there are any errors
        return !Object.values(errors).some(error => error !== "");
    };

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        if (validateFields()) {
            setIsLoader(true);
            const { cnfrmPassword, ...actualPayload } = payload;
            const { res, err } = await httpRequest<{ message: string }>({ method: "post", path: "/customer/reset-password", params: actualPayload });
            if (res) {
                if (res) {
                    toast(res?.message || "", { type: 'success' });
                    sessionStorage.removeItem("changePassword"); // Clear session storage
                    navigate("/doctor/login"); // Navigate to login page
                    setErrorField(initialErroState);
                    setPayload(initialState);
                }
            } else {
                toast(err, { type: 'error' });
            }
            setIsLoader(false);
        }
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("changePassword");
        let info: { email: string; otp: string } | null = null;
        if (storedData) {
            try {
                info = JSON.parse(storedData) as { email: string; otp: string };
            } catch (error) {
                console.error("Failed to parse session storage data:", error);
            }
        }
        if (!info) {
            navigate("/doctor/login"); // Navigate back if no session info
        } else {
            handleChange("email", info.email || "");
            handleChange("otp", info.otp || "");
        }
    }, []);

    return (
        <div className="customer-login-main">
            <div className="container-1600">
                <div className="customer-login-main-inner">
                    <div>
                        <h1 className="font-Poppins-SemiBold font-size-32px theme-color-green leading-none text-center lg-main-head">Welcome Back</h1>
                        <p className="font-size-16px theme-color-green font-Poppins-Regular">Please change your password</p>
                    </div>
                    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                        <div className="customer-login-main-inner-main">
                            <div>
                                <InputFeild
                                    type="password"
                                    label='Password'
                                    value={payload.newPassword}
                                    onChange={(val: string) => handleChange("newPassword", val)}
                                />
                                {errorField?.newPassword &&
                                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">{errorField?.newPassword}</p>
                                }
                            </div>
                            <div>
                                <InputFeild
                                    type="password"
                                    label='Confirm Password'
                                    value={payload.cnfrmPassword}
                                    onChange={(val: string) => handleChange("cnfrmPassword", val)}
                                />
                                {errorField?.cnfrmPassword &&
                                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">{errorField?.cnfrmPassword}</p>
                                }
                            </div>
                            <div className="login-btn-home-banner-parent flex items-center justify-center">
                                <CircleButton
                                    ButtonText={'Update'}
                                    loader={isLoader}
                                    type={"submit"}
                                    btnExtralClasses={'border border-[#00443f] hover:bg-[#fff]  hover:text-[#00443f]'}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DoctorConfirmPassword;